import { render, staticRenderFns } from "./FooterBasic.vue?vue&type=template&id=9602dac6&"
import script from "./FooterBasic.vue?vue&type=script&lang=ts&"
export * from "./FooterBasic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports